const getInitialValue = (rowData) => ({
  id: rowData.id,
  type: rowData.type,
  date: rowData.date,
  invoiceType: rowData.invoiceType,
  invoiceNumber: rowData.invoiceNumber,
  amountExclVat: rowData.amountExclVat,
  paymentType: rowData.paymentType,
  priceCurrency: rowData.priceCurrency,
  vendor: rowData.vendor,
  customer: rowData.customer,
  memo: rowData.memo,
})

export default getInitialValue
